

























import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
import { PriceRangeFilterDto } from '@/api';
import SearchFilterOption from '@/views/search/filter/SearchFilterOption.vue';
import VueSlider from 'vue-slider-component';

@Component({
  components: {SearchFilterOption, VueSlider},
})
export default class PriceFilterControl extends Vue {
  public priceRangeIntegers: PriceRangeFilterDto = {};
  public availablePriceRangeIntegers: PriceRangeFilterDto = {};
  public filterAvailable: boolean = false;

  @Model('change')
  public range!: PriceRangeFilterDto | null;

  @Prop({required: true})
  public priceFacets!: PriceRangeFilterDto;

  private localDisplayPriceFrom = -1;
  private localDisplayPriceTo = -1;

  public get isRangeActive(): boolean {
    return !!this.range && this.range.priceFrom !== undefined && this.range.priceTo !== undefined;
  }

  public get priceRangeIntegersAsArray(): number[] {
    return [this.priceRangeIntegers.priceFrom ?? 0, this.priceRangeIntegers.priceTo ?? 0];
  }

  public get minPrice(): number {
    return this.availablePriceRangeIntegers.priceFrom ?? 0;
  }

  public get maxPrice(): number {
    return Math.max(this.availablePriceRangeIntegers.priceTo ?? 0, this.priceRangeIntegers.priceTo ?? 0);
  }

  public get displayPriceFrom(): number | undefined {
    if (this.localDisplayPriceFrom > -1) {
      return this.localDisplayPriceFrom;
    }
    return this.priceRangeIntegers.priceFrom ?? undefined;
  }

  public get displayPriceTo(): number | undefined {
    if (this.localDisplayPriceTo > -1) {
      return this.localDisplayPriceTo;
    }
    return this.priceRangeIntegers.priceTo ?? undefined;
  }

  public mounted() {
    this.onRangeUpdate(this.range);
    this.onFacetsUpdate(this.priceFacets);
  }

  @Watch('priceFacets')
  public onFacetsUpdate(newRange: PriceRangeFilterDto): void {
    if (!newRange.priceFrom && !newRange.priceTo) {
      this.filterAvailable = false;
      return;
    }
    this.filterAvailable = true;
    const newLimits = {
      priceFrom: Math.floor(newRange.priceFrom ?? 0),
      priceTo: Math.ceil(Math.max(newRange.priceTo ?? 0, newRange.priceFrom ?? 0)),
    };
    let limitedSelection: PriceRangeFilterDto;
    if (!this.isRangeActive) {
      limitedSelection = newLimits;
    } else {
      limitedSelection = {
        priceFrom: this.limitToRange(this.priceRangeIntegers.priceFrom, newLimits),
        priceTo: this.limitToRange(this.priceRangeIntegers.priceTo, newLimits),
      };
    }
    this.availablePriceRangeIntegers = newLimits;
    this.priceRangeIntegers = limitedSelection;
  }

  @Watch('range')
  public onRangeUpdate(newRange: PriceRangeFilterDto | null): void {
    this.priceRangeIntegers = {
      priceFrom: Math.floor(newRange?.priceFrom ?? 0),
      priceTo: Math.ceil(Math.max(newRange?.priceTo ?? 0, newRange?.priceFrom ?? 0)),
    };
  }

  private limitToRange(target: number | undefined, limits: { priceFrom: number, priceTo: number }): number {
    const targetSafe = target ?? 0;
    const tooLow = targetSafe < limits.priceFrom;
    const tooHigh = targetSafe > limits.priceTo;
    if (tooLow) {
      return limits.priceFrom;
    } else if (tooHigh) {
      return limits.priceTo;
    } else {
      return targetSafe;
    }
  }

  public togglePriceFilter(): void {
    if (this.range) {
      this.$emit('change', null);
    } else {
      this.emitNewRange(this.minPrice, this.maxPrice);
    }
  }

  public updateLocalDisplayPrice(newBounds: number[]): void {
    this.localDisplayPriceFrom = newBounds[0];
    this.localDisplayPriceTo = newBounds[1];
  }

  public updatePriceFilterArray(newBounds: number[]): void {
    this.resetLocalDisplayPrices();
    this.emitNewRange(newBounds[0], newBounds[1]);
  }

  private resetLocalDisplayPrices() {
    this.localDisplayPriceFrom = -1;
    this.localDisplayPriceTo = -1;
  }

  private emitNewRange(priceFrom: number, priceTo: number) {
    const newRange: PriceRangeFilterDto = {priceFrom, priceTo};
    this.$emit('change', newRange);
  }
}
